import { useQuery, useQueryClient } from 'react-query';

import * as copilot from 'api/copilot';
import { CopilotConfiguration } from 'interfaces/copilot';

import { QueryOptions } from './types';

/**
 * Hook to query the Copilot configuration.
 *
 * @returns An object containing the Copilot configuration data, or `null` if Copilot is not available.
 */
export function useCopilotConfiguration(options?: QueryOptions<CopilotConfiguration | null>) {
  const queryKey = ['copilot', 'config'];
  const queryClient = useQueryClient();
  const { data, ...queryInfo } = useQuery<CopilotConfiguration | null>(
    queryKey,
    () => copilot.getCopilotConfiguration(),
    {
      ...options,
      onError: (error) => {
        // If the Copilot configuration endpoint returns an error, set the configuration to null.
        // This indicates Copilot is unavailable, e.g., due to organizational firewall blocking access.
        queryClient.setQueryData(queryKey, null);
        options?.onError?.(error);
      },
    }
  );

  return {
    ...queryInfo,
    copilotConfiguration: data,
  };
}
